var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C6DDEA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7589_5905",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7589_5905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6079 10.609C13.6079 10.609 13.6679 12.4055 13.9049 13.2103L15.7812 14.48L8.71802 15.5052L10.4025 13.2478C10.4025 13.2478 10.9111 10.8389 10.6444 9.94783C10.3775 9.05668 13.6079 10.609 13.6079 10.609",
    fill: "#F39C81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6172 10.8516C13.6172 10.851 13.0587 12.1556 12.0066 12.1269C10.9546 12.0982 10.7151 10.9442 10.7151 10.9442L13.6172 10.8516V10.8516Z",
    fill: "#ED985F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2475 9.79971C14.2475 9.79971 14.5873 8.15467 14.8244 7.6563C15.0615 7.15803 15.2591 4.93506 12.6313 4.82016C12.6313 4.82016 11.6237 4.93506 11.0706 4.60938C11.0706 4.60938 11.0706 4.93506 11.2088 5.05015C11.2088 5.05015 10.2998 4.83936 9.58867 5.60582C8.87731 6.37238 10.0628 9.05522 10.0035 9.68759L14.2475 9.79971V9.79971Z",
    fill: "url(#paint0_linear_7589_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1314 11.6243C12.8938 11.6112 14.2969 10.6268 14.2969 9.40755V7.50492C14.2969 7.05959 13.9768 6.69531 13.5855 6.69531H10.6773C10.2861 6.69531 9.9659 7.05959 9.9659 7.50492V9.29978C9.9659 10.5784 11.2572 11.6392 12.1314 11.6243",
    fill: "#F0B68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2936 8.52188C14.2936 8.52188 14.2896 7.37857 13.3559 7.20292C12.4225 7.02706 10.3331 7.76017 10.0369 6.92642C9.74043 6.09297 14.0753 6.10731 14.2936 6.63903C14.5119 7.17076 14.2936 8.52188 14.2936 8.52188",
    fill: "url(#paint1_linear_7589_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83569 29.4103C6.83569 29.4103 9.64221 29.9374 12.2027 29.9374C13.3195 29.9374 14.5328 29.8185 15.4989 29.6931C16.567 29.5558 17.3328 29.4103 17.3328 29.4103C17.3328 29.4103 17.9017 29.4586 17.5657 26.7375C17.3103 24.6667 17.3902 22.7972 17.4471 20.8735C17.4538 20.6597 17.4489 20.4067 17.4353 20.125C17.3262 17.8823 16.6269 13.8448 16.0939 13.628C16.0939 13.628 15.3014 13.3424 13.9016 13.2031C13.9016 13.2296 13.0889 14.3818 12.1245 14.5111C11.5253 14.2811 11.0547 14.0852 10.3991 13.2406C9.56874 13.3342 8.66305 13.4941 7.69459 13.7464C7.69459 13.7464 7.59375 14.1741 7.21325 21.5951C7.06209 24.5345 6.0278 29.4201 6.83569 29.4103",
    fill: "url(#paint2_linear_7589_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.045 22.466C20.1119 22.5201 19.8785 23.0812 19.5346 23.8124C18.8269 25.3147 17.6515 27.5332 17.6515 27.5332C17.8216 28.1593 18.0083 28.5462 18.0083 28.5462C19.9858 27.0394 21.2607 25.7573 22.0744 24.7742C23.2184 23.3915 23.4531 22.5988 23.4531 22.5988C19.0504 13.9062 15.9519 13.5859 15.9519 13.5859L16.318 19.3305C16.318 19.3305 19.8411 22.3015 20.045 22.466",
    fill: "url(#paint3_linear_7589_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6472 27.5333C17.8174 28.1594 18.0042 28.5462 18.0042 28.5462C19.9815 27.0394 21.2564 25.7574 22.0703 24.7743C21.4568 24.7302 20.5613 24.5174 19.5304 23.8125C18.8228 25.3147 17.6472 27.5333 17.6472 27.5333",
    fill: "#F0B68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.644842 22.5994C0.644842 22.5994 0.879577 23.3923 2.02353 24.7749C2.83721 25.7579 4.11231 27.0399 6.08955 28.5468C6.08955 28.5468 6.27632 28.1598 6.44632 27.5338C6.44632 27.5338 5.27107 25.3154 4.56343 23.813C4.21962 23.0818 3.98596 22.5206 4.05296 22.4667C4.21128 22.3389 6.36333 20.5252 7.32356 19.7162C7.60214 19.4811 7.78008 19.3312 7.78008 19.3312L8 13.6719C8 13.6719 5.04752 13.9069 0.644842 22.5994",
    fill: "url(#paint4_linear_7589_5905)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3804,
    height: 11.2686,
    transform: "matrix(-1 0 0 1 11.8047 21.3359)",
    fill: "url(#pattern0_7589_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44531 27.5333C6.27522 28.1594 6.08845 28.5462 6.08845 28.5462C4.11111 27.0394 2.8362 25.7574 2.02243 24.7743C2.6359 24.7302 3.53148 24.5174 4.56223 23.8125C5.26997 25.3147 6.44531 27.5333 6.44531 27.5333",
    fill: "#F0B68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8084 12.7656C13.8084 12.7656 14.122 12.8924 14.2109 13.2372C14.2109 13.2372 12.9529 14.4923 12.1297 14.5114L13.8084 12.7656Z",
    fill: "#D91E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 14.5124L10.5013 12.7031C10.5013 12.7031 10.166 12.917 10.1709 13.2692C10.1709 13.2692 11.4268 14.5603 12.125 14.5124",
    fill: "#D91E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4213 14.3839C12.4213 14.3839 13.6607 24.761 13.229 26.0259C13.0069 26.677 12.7095 27.2403 12.4731 27.6335C12.3033 27.9163 11.8814 27.9158 11.7128 27.632C11.3837 27.0778 10.9536 26.2757 10.9536 25.8687C10.9536 25.2094 11.8939 14.375 11.8939 14.375L12.4213 14.3839V14.3839Z",
    fill: "#D91E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7431 13.8707C12.7431 13.8707 11.9938 13.7978 11.5379 13.8428C11.4475 13.8517 11.3971 13.9476 11.4413 14.0247C11.569 14.2477 11.8298 14.6347 12.1025 14.6347C12.4857 14.6347 13.0826 13.8964 12.7431 13.8707",
    fill: "#B20B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7589_5905",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7589_5905",
    transform: "scale(0.0454545)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7589_5905",
    x1: 13.0836,
    y1: 4.88464,
    x2: 13.0735,
    y2: 7.05272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B64C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7589_5905",
    x1: 14.0129,
    y1: 4.88062,
    x2: 14.0098,
    y2: 7.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B64C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7589_5905",
    x1: 17.2838,
    y1: 14.345,
    x2: 17.3558,
    y2: 29.9134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595225,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7589_5905",
    x1: 23.1919,
    y1: 14.6068,
    x2: 23.2773,
    y2: 28.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595225,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7589_5905",
    x1: 7.74382,
    y1: 14.6869,
    x2: 7.82998,
    y2: 28.5252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595225,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7589_5905",
    width: 22,
    height: 22,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAEp0lEQVR4AZ3BTWhUVxgG4Pf7zrl3fpK5k2icRIM60RprNGAIIZp26caioHblzoVV0IXSQrbaVUuThVlIxYVVIwEpgWSTRYOkuklWJaVZCNYgxKLjD5NMfu7ce885X6egEEqtts+D9xkbGyP8DwrrTExM4NSpU7h9+zYBoPv37+PIkSN87do1GRgYwH+h8EaxWERzSwt37d/PURTRgQMH1OcnTujWYlEUoM6cPeuuXr2KD6VQc/z4cczMzODc+fN+XS4H1ppWlyuczgWeCQJY67K+9qS4bZt0dHRgZmYG76NGRkYwNzdHFy9e5KcLC/Z1uayKe/ZosUgrQPtWUjAJkjhJd3Z2NnTs2RPt27fPdXd304MHD/AuanR0FHfv3iVjDB3+7LC3efMWT4F8S6gn9hxZyRkRqxSRE1fnay1t7e2ut6fHXblyRfAOCjVDQ0O0vLxM1WrsZxub9FpklO8pB4+1gjCRCxjwiXwrghY4E1fD0PT19dnvBgZw8OBBjI6OYj1GTRiGXCg063Q6y8laJVWnTKISIg6j5qRqjSMkImBr47yQ80R0QbRu7Ozqzj958iR98uRJ/J26ceMGPX78mFpbt6Sd8jNh1Vj2FBiStxCnNLeQA5HiZiblahQzbVVEmrWHoH5D2N//pSmVSpibm8Nbanx8HF9fvkzwfQic5ylKa4eCdQa+5qwVyWitKs4ggDh2hDQDApKEAA2ilbW4io/a2tzw8LBMTk7SwsICGDXFtjb8ODKSICGrPa9qhCue1tZY0ewAY+x+ImhH2MRCDQIORMiHoIEE21npTLCxyf9qcJC/OH2aUaNQMzExIRcuXNDZtJ8l4UBEfCHJOIEBcSMRHCArRJSF0FMRZ4hk0Tr3kpgyWkRn0vWmKZVzK6uLMjY25hRqSqUSvv3mG1pKp+GikFghsCJZRbyBICyEEIR6crQGIMWsymBYImZ2VLVEcexsGDQFtLq4mPT09IjCGz9NTspv09PuxLFjJqnaNAtHAlcASQjQJkWkiWhZBCmIswT4AqonRsJQMZNAxMmrFy94YGAgYrzx6+ws2tvbXRxFiZW44pRLiFEiQj0DL63DH46QIZIMNOVAqqqAV0Re6MTEwhTXpzL0slQKZ2dnibFOLpfDoUOHTByGywJZFkFEoNdgrAAgFqkCXBLBUxEXQHFVXGzhNMMqfyWqpvs++VQ/fPhQK6xz7949lMtl9Pb22uLWrYnyM0liE2HHeSGII0REUicWSwRXEVCDBa8qikPH2mrPXyUFw0Cs8A/Gx8dx9OhRlyQRZ+uChFlELGKt9RqJe8bEORGJxNMVMcmqFW3jtSUWsewBUcfevU7hHe7cuYOGfJ527tyRZBvyksTGsshGQJE4SWntVSSx1mNldEqZR78/qo6Pjq7cvHXLzc/PQ+FfTE9P2+L27bYxn0+aNjSsZoJgrRrFRjx/0SVhTL7HHkmlHMdcE507c0bm5+fxF4X3mJqawqamJtfV1SXDN3+IKkvlaMe2VitEamM+WPV93926fj35fmjIPXv+HG8xPsDg4CB2794tly5dws9TU6a/v7/68a5dlUKhEBljnNZafpmdxXp/AtwDYbkYleJNAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIcon);
export default __webpack_public_path__ + "static/media/man-icon.fe2d42bbfe8be52af70532141b1efd1c.svg";
export { ForwardRef as ReactComponent };